import React, { useState } from 'react';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  HStack,
} from '@chakra-ui/react';
import { VscFeedback } from 'react-icons/vsc';

const RoleModal = ({ children }) => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const handleOpenModal = () => {
    setIsOpenModal(true);
  };

  const handleCloseModal = () => {
    setIsOpenModal(false);
  };

  return (
    <>
      <Button
        onClick={handleOpenModal}
        backgroundColor={'#4945FF'}
        _hover={{ backgroundColor: '#7B79FF' }}
        color="white"
      >
        <VscFeedback />
      </Button>

      <Modal isOpen={isOpenModal} onClose={handleCloseModal}>
        <ModalOverlay />
        <ModalContent
          fontFamily={"'Jura', sans-serif"}
          backgroundColor={'#212134'}
          color={'white'}
        >
          <ModalHeader>Роль</ModalHeader>
          <ModalCloseButton />
          <ModalBody>{children}</ModalBody>
          <ModalFooter>
            <Button onClick={handleCloseModal}>Закрыть</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default RoleModal;
